import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { StepperComponent } from '../stepper/stepper.component';
import { MercadoPagoService } from '../../services/mercado-pago.service';
import { BtnWalletComponent } from '../btn-wallet/btn-wallet.component';
import { CartDetailComponent } from "../cart-detail/cart-detail.component";
import { AdressFormComponent } from '../adress-form/adress-form.component';
import { OrdersService } from '../../services/orders.service';
import { CommonModule } from '@angular/common';
import { GeneralEmitterService } from '../../services/general-emitter.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { OrderPaymentProcessService } from '../../services/order-payment-process.service';
import { switchMap } from 'rxjs';
import { OrderImageUploadComponent } from './order-image-upload.component';

@Component({
  selector: 'app-cart-order-flow',
  standalone: true,
  imports: [StepperComponent, BtnWalletComponent, CartDetailComponent,
    AdressFormComponent, CommonModule, ToastModule, OrderImageUploadComponent],
  templateUrl: './cart-order-flow.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [MessageService],
  styleUrl: './cart-order-flow.component.scss'
})
export class CartOrderFlowComponent {
  public labels = ['Revisión de solicitud', 'Realizar Pago', 'En proceso de envío', 'Entregado']
  public index = 1;
  showPayment: boolean = false;
  showPayment22: boolean = false;
  products: any = [];
  listItems: any = [];
  paymentId = '';
  orderList: any = [];
  paymentList: any= [];
  orderInfo: string = '';
  totalAmount: number = 0;
  urlParams: any = {};
  usr: any = localStorage.getItem('usr') || '';

  constructor(private mpService: MercadoPagoService,
    private orderService: OrdersService,
    private emitterData: GeneralEmitterService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private orderPaymentProcessService: OrderPaymentProcessService
  ) { }

  ngOnInit() {
    this.usr = localStorage.getItem('usr') || '';
    this.products = JSON.parse(localStorage.getItem('productCart') || '[]');
    this.orderProducts();
    // this.generate();
    this.getOrders();

    //https://s6pb58kf-4200.usw3.devtunnels.ms/?
    
   
  }

  /**
   * ############
   */

  getOrders() {
    // this.emitterData.showSpinner.emit(true);
    this.orderService.getListOrder(this.usr).subscribe({
      next: (res: any) => {
        this.orderList = res.listOrders ?? [];
        console.log('this.orderList :', this.orderList);
        // this.emitterData.showSpinner.emit(false);
      },
      error: (err: any) => {
        if ( err?.status == 401 ) {
          this.messageService.add({ severity:'error', summary: 'Ocurrió un error', detail: "Su sesión ha expirado, por favor inicie sesión nuevamente." });
        } else {
          this.messageService.add({ severity:'warning', summary: 'Ocurrió un error', detail: err?.message ?? '' });
        }
      }
    });
  }

  /**
   * ############
   */

  orderProducts() {
    this.listItems = [];
    this.products.forEach((item: any) => {
      let sku = this.listItems.find((val: any) => val.id == item.sku);
      if ( !sku ) {
        let newItem = item;
        this.listItems.push(
         {
          "id": item?.sku,
          "title": item?.nombre,
          "quantity":1,
          "unit_price": item?.precioUnitario
        });


      } else {
        sku.quantity++;
      }
    });
  }

  continueQuotation() {
    this.index++;
  }
  rejectQuotation() {

  }

  setPayment(ix: any) {
    this.orderInfo = this.orderList[ix]?.order_id || '';
    let list = this.orderList[ix]?.details || [];
    let total = 0;

    list.forEach((item: any) => {
      this.paymentList.push(
        {
          "id": item?.sku,
          "title": item?.product,
          "quantity":item?.quantity,
          "unit_price": Number(item?.unit_price)
        });
        total += (item?.quantity * Number(item?.unit_price)) || 0;
    });

    const iva = total * 0.16; // Calculate 16% IVA
    total += iva; // Add IVA to total
    this.paymentList.push(
      {
        "id": "000002",
        "title": "Iva",
        "quantity": 1,
        "unit_price": iva
      });

    this.paymentList.push(
        {
          "id": "00001",
          "title": "Envio",
          "quantity":1,
          "unit_price": Number(this.orderList[ix]?.shippingCost) || 0
        });
        total += (Number(this.orderList[ix]?.shippingCost)) || 0;

    this.totalAmount = total;
  }

  generatePayment(ix: any) {
    this.showPayment = true;
    this.paymentList = [];
    this.setPayment(ix);
    let pay = {
      "order": this.paymentList
    };
    console.log('pay :', pay);

    this.mpService.createOrder(pay).subscribe({
        next: async (res:any) => {
          this.paymentId = res?.id || '';
          localStorage.setItem('idPago', this.paymentId); 
          console.log('111')
          await this.generateProcess();
          console.log('2222')
          
          
          // this.showPayment22 = res?.id;
        }, 
        error: (err: any) => {
          this.showPayment22 = false;
          
        console.log('***err :', err);
        },
        complete: () => {
          this.showPayment22 = this.paymentId ? true : false;
        }
      });

  }

  generateProcess() {
    let payload = {
      "order_id": this.orderInfo,
      "status": "pending",
      "status_detail": "pending",
      "amount": this.totalAmount,
      "preferenceId": this.paymentId,
      "currency": "MXN"
    }

    this.orderPaymentProcessService.createPaymentProcess(payload).subscribe({
      next: (res:any) => {
        console.log('res :', res);
      },
      error: (err: any) => {
        console.log('***err :', err);
      }
    });
    
  }

  continueOrder(value: string, orderId: string) {
    let payload = {
      orderId: orderId,
      usr: this.usr,
      status: value
    }
    this.orderService.updateOrderStatus(payload)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({ severity:'success', summary: 'Éxito', detail: 'Cotización aceptada' });
          this.getOrders();
        },
        error: (err: any) => {
        console.log('err :', err);
          this.messageService.add({ severity:'error', summary: 'Ocurrió un error', detail: (err?.error?.message || err?.message) ?? '' });
        }
      });
  }

  cancelPayment() {
    this.showPayment=false;
    this.paymentId='';
    localStorage.removeItem('idPago');
    this.paymentList=[];
  }

  validarPago(paymentId: string) {
    
    if ( !paymentId ) {
      this.messageService.add({ severity:'error', summary: 'Ocurrió un error', detail: 'No se encontró el ID de pago' });
      return;
    }
    this.mpService.getPaymentStatusValue(paymentId).subscribe({
      next: async (payment) => {
        await this.updatePaymentStatus(payment, paymentId);
        console.log('Estado del pag **** o:', payment);
      },
      error: () => console.log('Error al obtener el estado del pago')
      // next: payment => this.showPaymentStatus(payment.status, payment.statusDetail),
      // error: () => this.showPaymentStatus('unknown')
    });
  }

  updatePaymentStatus(paymentData: any, paymentId: string = '') {
      let payload = {
        status: paymentData.status,
        status_detail: paymentData.status_detail,	
        processDate: paymentData.processDate,
        lastUpdateDate: paymentData.lastUpdateDate,
        approvedDate: paymentData.approvedDate
  
      };
      
      this.orderPaymentProcessService
      .updatePaymentProcessbyPayment(paymentId, payload)
      .pipe(
        switchMap(paymentProcess => {
        console.log('paymentProcess :', paymentProcess);
          const payloadOrder = {
            orderId: paymentProcess.data.order_id,
            usr: this.usr,
            status: paymentData.status === 'approved' ? 'Preparando Envío' : 'Cotización Aceptada',
            status_payment: paymentProcess.data.status,
            payment: paymentProcess.data.paymentId
          };
  
          return this.orderService.updateOrderStatus(payloadOrder);
        })
      )
      .subscribe({
        next: orderResponse => {
          console.log('Pago y orden actualizados:', orderResponse);
        },
        error: error => {
          console.error('No se pudo actualizar el pago o la orden:', error);
        }
      });
    }
      
}